export const enum SnAuditOperation {
  View = 'VIEW',
  List = 'LIST',
  Delete = 'DELETE',
  Create = 'CREATE',
  Edit = 'EDIT',
  ViewLive = 'VIEW LIVE',
  ViewRecord = 'VIEW RECORDED',
  ViewVaultRecording = 'VIEW VAULT RECORDING',
  SavePtzPreset = 'SAVE PTZ PRESET',
  DeletePtzPreset = 'DELETE PTZ PRESET',
  EditPtzPreset = 'EDIT PTZ PRESET',
  MovePtz = 'MOVE PTZ',
  VideoScreenShot = ' VIDEO SCREENSHOT',
  DownloadScreenShot = 'DOWNLOAD SCREENSHOT',
  ClipDownloaded = 'CLIP DOWNLOADED',
  InvestigateMap = 'INVESTIGATE MAP',
  Confirmation = 'CONFIRMATION',
}
